import React, { useEffect } from "react";
import { getCookies } from "cookies-next";
import Header from "../../components/header";
import FooterSub from "../../components/footer/footer-sub";
import Contactus from "../../components/contactus";
import store, { withServerStore } from "../../store";
import {
  getAddressInfo,
  getBrandList,
  getCategoryList,
  getLocations,
  getMetaData,
  setLocations,
  setBrandList,
  setCategoryList,
  setAddressInfo,
  setCurrentLocationId,
} from "../../store/actions";
import {
  getLocationIdUsingCityStateSlug,
  get_cookie,
  makeCityStateSlugUsingLocation,
  metaTags,
  setCityStateSlugInCookie,
  setCurrentLocationIdInCookie,
} from "../../utils";
import MetaTags from "../../components/meta-tags";
// import CookiesModal from "components/modals/cookiesModal";

const ContactUs = ({
  locations,
  brandList,
  categoryList,
  addressInfo,
  currentLocationId,
  cityStateSlug,
}) => {
  let cityName = "";
  const is_mobile_app = get_cookie("is_mobile_app");

  if (get_cookie("redirectUrl")) {
    const value = get_cookie("redirectUrl");
    if (value != "/") {
      const arr = value.split("/");
      cityName = arr[2];
    }
  }

  const mapObj = [
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d826.2277842250319!2d-118.40284746760409!3d34.0717921666901!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9e7029521f9bd9e7!2sFalcon%20Car%20Rental!5e0!3m2!1sen!2sin!4v1669269926798!5m2!1sen!2sin",
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14370.869759317638!2d-80.140494!3d25.779895!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x430c1be73be4f4c0!2sFalcon%20Car%20Rental%20Miami!5e0!3m2!1sen!2sin!4v1669270184220!5m2!1sen!2sin",
  ];

  let mapObjValue = mapObj["0"];
  if (cityName) {
    mapObjValue = mapObj["1"];
  }

  /********************
  @purpose : Set current location id in cookie
  @Parameter : {currentLocationId}
  @Author : INIC
  ******************/
  setCurrentLocationIdInCookie(currentLocationId);

  /********************
  @purpose : Set cityStateSlug in cookie
  @Parameter : {cityStateSlug}
  @Author : INIC
  ******************/
  setCityStateSlugInCookie(cityStateSlug);

  useEffect(() => {
    /********************
  @purpose : Set location data,brandList,
  categoryList,addressInfo,currentLocationId in redux
  @Parameter : {locations}
  @Author : INIC
  ******************/
    store.dispatch(setLocations(locations));
    store.dispatch(setBrandList(brandList));
    store.dispatch(setCategoryList(categoryList));
    store.dispatch(setAddressInfo(addressInfo));
    store.dispatch(setCurrentLocationId(currentLocationId));
  }, [currentLocationId, cityStateSlug]);

  return (
    <>
      {/****************
        @purpose : SEO Intigration
        @Author : INIC
        ******************/}
      <MetaTags metaData={metaTags} />

      {is_mobile_app !== "yes" && (
        <Header
          locations={locations}
          brandList={brandList}
          categoryList={categoryList}
          currentLocationId={currentLocationId}
          headerDark={false}
          headerWhite={true}
          currentPage="contact-us"
        />
      )}
      {/* About us banner : Start */}
      <section className="cms-page position-relative">
        <div className="cms-banner">
          <img src="/assets/images/banner-cms.jpg" alt="Falcon Car Rental" />
        </div>
        <div className="mapping">
          <iframe
            src={mapObjValue}
            width="100%"
            height="540"
            frameBorder="0"
            allowFullScreen=""
          ></iframe>
        </div>
        <div className="cms-banner-title text-center inner-wrapper d-none">
          <h2 className="title ff-poppins fw-regular text-white mb-35">
            Contact Us
          </h2>
          <h5 className="sub-title mb-0 fw-regular ff-poppins font-34 text-white">
            We are conveniently located in the heart of Beverly Hills
          </h5>
        </div>
      </section>
      {/* About us banner : End */}

      <div className="contact-us-page py-60">
        <div className="custom-container">
          <div className="inner-wrapper">
            <div className="d-flex justify-content-between align-items-start flex-column flex-md-row">
              <Contactus currentLocationId={currentLocationId} />

              <div className="contact-card mt-3 mt-sm-0">
                <h4 className="font-30 ff-hel-med text-black mb-30">Contact</h4>
                <ul className="list-unstyled contact-list">
                  <li>
                    <a
                      href={`tel:${addressInfo.company_phone}`}
                      className="phone-number font-22 ff-hel-reg"
                    >
                      <span className="icon icon-phone"></span>
                      {addressInfo.company_phone}
                    </a>
                  </li>
                  <li>
                    <span className="icon icon-location"></span>
                    <address className="font-22 mb-0 ff-hel-reg">
                      {addressInfo.company_address}
                    </address>
                  </li>
                  <li>
                    <span className="icon icon-clock"></span>
                    <div className="d-flex justify-content-start w-100">
                      <div className="d-flex flex-column week-day">
                        <span className="font-22">Monday - Friday</span>
                        <span className="muted font-24 mt-1">
                          {addressInfo.company_time_mon_fri}
                        </span>
                      </div>
                      <div className="d-flex flex-column week-day">
                        <span className="font-22">Saturday - Sunday</span>
                        <span className="muted font-24 mt-1">
                          {addressInfo.company_time_sat_sun}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {is_mobile_app !== "yes" && <CookiesModal />} */}

      {is_mobile_app !== "yes" && <FooterSub currentPage="contact-us" />}
    </>
  );
};
export default ContactUs;

/********************
  @purpose : server side rendering
  @Parameter : {}
  @Author : INIC
  ******************/
export const getServerSideProps = withServerStore(async ({ req, res, store }) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=0, stale-while-revalidate=1"
  );

  let id = "";
  let cityStateSlug = "";
  const tempCityStateSlug = getCookies({ req, res }).cityStateSlug;

  let list = "";
  let locations = "";
  let brandList = "";
  let categoryList = "";
  let addressInfo = "";
  let metaData = "";

  // get locations list
  list = await store.dispatch(getLocations(true));

  if (list && list.statusCode != "503") {
    locations = list?.data;
    if (tempCityStateSlug) {
      id = getLocationIdUsingCityStateSlug(locations, tempCityStateSlug);
    } else {
      id = locations["0"]["id"];
      cityStateSlug = makeCityStateSlugUsingLocation(locations["0"]);
    }

    // get meta data of home page
    metaData = await store.dispatch(getMetaData(id, "home", "pageName"));

    // get brand list using location id
    brandList = await store.dispatch(getBrandList(id));

    // get category list using location id
    categoryList = await store.dispatch(getCategoryList(id));

    // get address info using location id
    addressInfo = await store.dispatch(getAddressInfo(id));
  } else {
    return {
      redirect: {
        destination: "/maintenance",
      },
    };
  }

  return {
    props: {
      metaData: metaData,
      locations: locations,
      brandList: brandList,
      categoryList: categoryList,
      currentLocationId: id,
      addressInfo: addressInfo,
      cityStateSlug: cityStateSlug ? cityStateSlug : tempCityStateSlug,
    },
  };
});
